import styled from "styled-components";
import { Button, Flex } from "discover.medical.react-component-library";

export const CheekyListItem = styled(Flex)`
  padding-bottom: 0.5rem;
  &:not(:first-child) {
    padding-top: 0.5rem;
  }

  ${({ theme }) => `border-bottom: 1px solid ${theme.colors.gray400}`}
`;

export const StyledButton = styled(Button)`
  vertical-align: middle;
`;

export const StyledBookmarkFlex = styled(Flex)`
  width: 100%;
`;

export const StyledPubTypeFlex = styled(Flex)`
  flex: 1;
`;

export const StyledTitleFlex = styled(Flex)`
  flex: 2;
`;
